// Configuracion de Sentry comun al navegador y al servidor, sin importar el SDK: instrumentation.ts
// (servidor) no debe arrastrar las integraciones que solo existen en el navegador.

// Errores del front (web y dashboard) y del servidor de Next en Sentry, proyecto holaglow-front.
// El DSN no es secreto: va en el codigo que descarga el navegador, igual que la clave de Bugsnag.
export const SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  'https://53a3f2bbaab3f89992355270285540aa@o4511411193315329.ingest.de.sentry.io/4512311291478097';

// Los calcula next.config.js: 'development' en local, 'staging' en las previsualizaciones de Vercel.
export const SENTRY_ENVIRONMENT =
  process.env.NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE || 'development';
export const SENTRY_RELEASE = process.env.NEXT_PUBLIC_BUGSNAG_APP_VERSION;

// En local no se envia nada.
export const SENTRY_ENABLED = SENTRY_ENVIRONMENT !== 'development';

// Datos de pacientes: Sentry 11 recoge por defecto cabeceras, cookies, cuerpos de peticiones y respuestas,
// parametros de URL y variables locales. Aqui no se recoge nada de eso; basta con la traza y la URL.
export const SENTRY_DATA_COLLECTION = {
  userInfo: false,
  cookies: false,
  // Solo el navegador (User-Agent), para saber si el error es de Safari, de la app de Instagram, de un bot...
  httpHeaders: { request: { allow: ['User-Agent', 'user-agent'] }, response: false },
  httpBodies: [],
  urlQueryParams: false,
  graphQL: { document: true, variables: false },
  databaseQueryData: false,
  stackFrameVariables: false,
};
